<template>
  <div>
    <b-row>
      <div class="col-md-12">
        <card-list-info header="Detail" :items="locationInfo"></card-list-info>
      </div>
    </b-row>
    <b-row>
      <div class="col-md-12">
        <b-card no-body header="Location" class="p-0">
          <base-map
            :marker="marker"
            :popup="popup"
            :center="center"
            :isCircle="isCircle"
            :latlngs="latlngs"
            :radius="radius"
            :coordinates="coordinates">
          </base-map>
        </b-card>
      </div>
    </b-row>
  </div>
</template>
<script>
import L from 'leaflet';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import values from 'lodash/values';

import CardListInfo from '@/components/CardListInfo';
import BaseMap from '@/components/BaseMap';

export default {
  components: {
    CardListInfo,
    BaseMap,
  },
  data() {
    return {
      center: [0, 0],
      marker: { lat: 0, lng: 0 },
      geojson: {
        type: 'FeatureCollection',
        features: [],
      },
      popup: '',
      isCircle: false,
      radius: 75,
      coordinates: [0, 0],
      latlngs: [],
    };
  },
  created() {
    this.$store.dispatch('shipment_md/locations/LOAD_DETAIL_DATA');
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['shipment_md/locations/get_detail_data'];
    },
    locationInfo() {
      const { code, name } = this.detailedInfo;
      let { company } = this.detailedInfo;
      company = company || {};

      const infoList = [
        { key: 'code', label: 'Code', value: code },
        { key: 'name', label: 'Name', value: name },
        { key: 'company', label: 'Company', value: company.name },
      ];
      return infoList;
    },
  },
  watch: {
    detailedInfo(data) {
      const {
        name, longitude, latitude, geometry, metadata,
      } = data;

      this.popup = name;
      const { radius } = metadata;
      this.radius = isUndefined(radius) || isNull(radius) ? this.radius : metadata.radius;
      this.isCircle = !isNull(metadata) && geometry.type === 'Point' ? !this.isCircle : this.isCircle;
      this.latlngs = geometry.coordinates;

      if (this.isCircle) {
        if (isNull(longitude) && isNull(latitude)) {
          this.center = geometry.coordinates;
          this.coordinates = geometry.coordinates;
          this.marker = { lat: geometry.coordinates[0], lng: geometry.coordinates[1] };
        } else {
          this.center = [latitude, longitude];
          this.coordinates = [latitude, longitude];
          this.marker = { lat: latitude, lng: longitude };
        }
      } else {
        const polygon = L.polygon(geometry.coordinates);
        const center = polygon.getBounds().getCenter();
        this.center = values(center);
        this.marker = center;
      }
    },
  },
};
</script>
<style lang="sass">
.leaflet-control-container
  height: 500px !important;
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/locations/detail/Preview.vue